<template>
  <div>
    <page-header>
      <template v-slot:title>
        <div>
          Novo lançamento 💵
        </div>
      </template>
    </page-header>
    <default-card>
      <template slot="title-left"> </template>
      <template slot="title-right"> </template>
      <template slot="content">
        <form-register-movement create_movement class="mt-n1"></form-register-movement>
      </template>
      <template slot="actions"> </template>
    </default-card>
  </div>
</template>

<script>
  export default {
    name: 'RegisterMovement',
    components: {
      FormRegisterMovement: () => import ('./forms/FormRegisterMovement.vue'),
    },
    data() {
      return {
        //loading: false,
      }
    },

    // mounted () {
    //   this.getData()
    // },

    // methods: {
    //   getData(){
    //     this.loading = true
    //     setTimeout(() => this.loading = false, 1200)
    //   },
    // }
  }
</script>

<style lang="scss" scoped>

</style>